import { render, staticRenderFns } from "./UnitMaster.vue?vue&type=template&id=5a1fa79e&scoped=true"
import script from "./UnitMaster.vue?vue&type=script&lang=js"
export * from "./UnitMaster.vue?vue&type=script&lang=js"
import style0 from "./UnitMaster.vue?vue&type=style&index=0&id=5a1fa79e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1fa79e",
  null
  
)

export default component.exports